import { Box, CircularProgress, Typography, styled } from "@mui/material";
import { motion } from "framer-motion";

const easing = [0.6, -0.05, 0.01, 0.99];
const fadeInUp = {
	initial: {
		y: 60,
		opacity: 0,
		transition: { duration: 0.6, ease: easing },
	},
	animate: {
		y: 0,
		opacity: 1,
		transition: {
			duration: 0.6,
			ease: easing,
		},
	},
};

export function Loading() {
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				height: "100vh",
				width: "100vw",
				flexDirection: "column",
			}}
		>
			<LoadingAnimation />
			<Typography
				component={motion.p}
				{...fadeInUp}
				variant="body2"
				align="center"
				color={"primary.main"}
				sx={{ mt: 3 }}
			>
				Carregando Dados...
			</Typography>
		</Box>
	);
}

export const LoadingAnimation = styled(CircularProgress)(({ theme }) => ({
	"&.MuiCircularProgress-colorPrimary": {
		color: theme.palette.primary.main,
	},
}));
